import base from "./base.service";

const getDroneList = () => base.get('/util/drone-list');
const updatePortfolio = payload => base.put('/users/update-portfolio', payload);

export const portfolioService = {
    getDroneList,
    updatePortfolio
}
